// extracted by mini-css-extract-plugin
export default {"settings":"ZuEW","menu":"FOec","form":"Kiib","autoSubmit":"vHSp"};